import { compareVersions, validate } from "compare-versions";
import { FEATURE_VERSION_MAP } from "@constants/testConstants/versionConstants";
import { TestType, VFABehaviour } from "types/testTypes";
import { countsFixationLossesOnMovingFixation, isSuprathresholdBehaviour } from "@utils/TestUtils";

export interface MovingFixationCatchTrialAvailability {
  catchTrialsSwitchedOn: boolean;
  headsetVersion?: string | null;
}

const isHeadsetPresentingCatchTrials = (headsetVersion?: string | null): boolean =>
  typeof headsetVersion === "string" &&
  validate(headsetVersion) &&
  compareVersions(headsetVersion, FEATURE_VERSION_MAP.vfaMovingFixationCatchTrials) >= 0;

export function presentsMovingFixationCatchTrials(
  testType: TestType | null | undefined,
  testBehaviour: VFABehaviour | string | number | null | undefined,
  { catchTrialsSwitchedOn, headsetVersion }: MovingFixationCatchTrialAvailability,
): boolean {
  return (
    catchTrialsSwitchedOn &&
    !!testType &&
    countsFixationLossesOnMovingFixation(testType) &&
    isSuprathresholdBehaviour(testBehaviour) &&
    isHeadsetPresentingCatchTrials(headsetVersion)
  );
}
